<p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4" animationDuration="1"> </p-progressSpinner>
